export default "__VITE_ASSET__KW_RlQ6___"